
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { Database } from '@/integrations/supabase/types';

export class SupabaseClientWrapper {
  private client: SupabaseClient<Database>;

  constructor() {
    const supabaseUrl = 'https://awsqgjvacnuporuonebg.supabase.co';
    const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF3c3FnanZhY251cG9ydW9uZWJnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc2NjI3MjksImV4cCI6MjA2MzIzODcyOX0.BrB0YeV649FU6XsvyUj8uAkPPZQdxnrPxW5GcWC-jdA';
    
    this.client = createClient<Database>(supabaseUrl, supabaseKey);
  }

  getClient(): SupabaseClient<Database> {
    return this.client;
  }
}
